import React, { useState, useEffect, useContext } from 'react';
import EditAssignedBase from '../../EditAssigned'
import { ShopContext } from '../../contexts/Shop'
import { CustomerContext } from '../../contexts/Customer'
import { SubscriptionsContext } from '../../contexts/Subscriptions'
import { EnrollmentsContext } from '../../contexts/yolk/Enrollments'

export default function EditAssigned(props) {
  const shop_name = useContext(ShopContext)
  const [customer] = useContext(CustomerContext)
  const subscriptions = useContext(SubscriptionsContext)
  const [enrollments, fetchEnrollments, fetchEnrollmentsState, upsertEnrollment] = useContext(EnrollmentsContext)

  const subscription = props.subscription || subscriptions.find((s) => s.id == props.subscription_id)

  return (<EditAssignedBase forAccount={true}
  is_office_hour={props.is_office_hour}
  className={props.className}
  unassignedLinkText={props.unassignedLinkText}
  subscription_id={subscription.id}
  assigned_to={subscription.assignedToEmail}
  enrollment_id={subscription.enrollmentId}
  order_id={subscription.orderId}
  line_item_id={subscription.lineItemId}
  tabSelected={props.tabSelected}
  line_item_quantity={subscription.lineItemQuantity}
  section_id={subscription.sectionId} sku={subscription.sku} cid={customer.id} cemail={customer.email} shop_name={shop_name}
  onSave={upsertEnrollment} onSaving={props.onSaving}/>)
}
